<template>
  <v-app>
    <v-img
      :class="{
        'v-image--sm': this.$vuetify.breakpoint.smAndDown,
        'v-image--md': this.$vuetify.breakpoint.mdAndDown
      }"
      src="img/sidebar-2.jpg"
      gradient="to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)"
      height="0"
    >
      <router-view />
    </v-img>
  </v-app>
</template>

<script>
  export default {
    name: 'LoginIndex',
  }
</script>
